// extracted by mini-css-extract-plugin
export default {"badge":"BadgeCor_badge__GI2fX","end":"BadgeCor_end__X+SmC","noStart":"BadgeCor_noStart__8rMDW"};